<template>
    <article
        :lang="issue.lang"
        dusk="AddOnViewer"
        class="AddOnViewer flex w-full flex-col gap-4 text-[calc(1rem*var(--add-on-font-scale,1))] text-theme-text"
        :class="{ 'mx-auto max-w-[68ch]': ui.addOnsPanel.fullscreen }"
        :style="{ '--add-on-font-scale': ui.addOnsPanel.fontScale }"
    >
        <header>
            <!-- eslint-disable vue/no-v-html -->
            <p
                v-if="addOn.pretitle"
                dusk="AddOnViewerPretitle"
                class="mb-1 text-[0.6875em] font-semibold uppercase tracking-wider text-theme-accent"
                v-html="addOn.pretitle"
            ></p>
            <!-- eslint-enable vue/no-v-html -->
            <!-- Focusable so the swap from the list lands the reader on what opened,
                 and marked so the panel's trap opens there too. -->
            <h2
                ref="title"
                tabindex="-1"
                data-autofocus
                dusk="AddOnViewerTitle"
                class="m-0 text-[1.25em] font-semibold leading-tight tracking-tight focus:outline-none"
            >
                {{ addOn.title }}
            </h2>
            <p v-if="addOn.author" dusk="AddOnViewerAuthor" class="mt-1 text-[0.875em] italic text-theme-toolbar-icon">
                {{ byline }}
            </p>
            <p v-if="addOn.byLine" dusk="AddOnViewerByLine" class="mt-1 text-[0.875em] text-theme-toolbar-icon">
                {{ addOn.byLine }}
            </p>
        </header>

        <figure v-if="addOn.imageUrl" dusk="AddOnViewerFigure" class="m-0 overflow-hidden rounded">
            <img class="pointer-events-none w-full" :src="addOn.imageUrl" :alt="addOn.imageCaption || ''" />
            <figcaption v-if="addOn.imageCaption" class="px-3 py-1.5 text-[0.75em] text-theme-toolbar-icon">
                {{ addOn.imageCaption }}
            </figcaption>
        </figure>

        <AddOnBody ref="body" :content="addOn.body" :content-language="issue.lang" />
    </article>
</template>

<script>
'use strict';

import { mapState } from 'vuex';
import AddOnBody from './AddOnBody.vue';

export default {
    name: 'AddOnViewer',
    components: { AddOnBody },
    props: {
        addOn: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState(['issue', 'localizations', 'lang', 'ui']),
        byline() {
            return `${this.localizations[this.lang].by} ${this.addOn.author}`;
        },
    },
    watch: {
        // A marker tapped while another piece is open swaps the content in
        // place, and the reader should land at the top of what they asked
        // for. When the swap came from a control inside the panel — the
        // previous/next buttons — the reader is mid-interaction there, so
        // focus stays put and the content rewinds instead. The decision waits
        // for the render: the button pressed at either end unmounts, and then
        // there is nothing left to keep focus on.
        'addOn.id'() {
            this.$nextTick(() => {
                if (this.panelKeepsFocus()) this.rewind();
                else this.focusTitle();
            });
        },
    },
    mounted() {
        this.focusTitle();
    },
    methods: {
        focusTitle() {
            this.$refs.title?.focus();
        },
        panelKeepsFocus() {
            const active = document.activeElement;
            const panel = this.$el.closest('.SidebarPanel');
            return Boolean(panel && active && panel.contains(active) && !this.$el.contains(active));
        },
        // The panel's content box is what scrolls, and the viewer is its child.
        rewind() {
            if (this.$el.parentElement) this.$el.parentElement.scrollTop = 0;
        },
        releaseEmbeds() {
            this.$refs.body.releaseEmbeds();
        },
    },
};
</script>
